import React from "react";
import { createRoot } from "react-dom/client";

import TagManager from "react-gtm-module";
import * as Sentry from "@sentry/react";

import App from "./App";

if (!!process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.05,
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/api\.begin\.mychoice\.ca\//,
    ],
    // Session Replay
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

if (
  process.env.REACT_APP_ENV === "production" &&
  process.env.REACT_APP_GTAG_ID
) {
  TagManager.initialize({
    gtmId: process.env.REACT_APP_GTAG_ID,
    dataLayerName: "PageDataLayer",
  });
}

const root = createRoot(document.getElementById("root") as HTMLDivElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
